import { IInterceptorIO, TInfoIO } from '../../../core/interceptor';
import { RequestAPI } from '../../../adapters/api';

import f1 from'../../../pip/library/pi-f1/pi-f1.js';

export class APIRequestDefaults implements IInterceptorIO<RequestAPI> {
  readonly id = 'api-defaults';
  readonly type = 'request';

  readonly settings = {
    defaults: {
      method: 'GET',
      referrerPolicy: 'origin-when-cross-origin',
      credentials: 'same-origin',
      redirect: 'manual',
      cache: 'default',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      }
    }
  };

  async transform(infoIO: TInfoIO<RequestAPI>) {
    return f1.merge(
      'over',
      f1.merge(
        'over',
        {
          packet: this.settings.defaults
        },
        {
          packet: infoIO.options.defaults
        }
      ),
      infoIO
    ) as TInfoIO<RequestAPI>;
  }
}
